( function () {
    'use strict';
    function zeroPad(num, places) {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join("0") + num;
    }    
    ( function ( $ ) {
        $('.insight-slick-slider').on('init', function(event, slick) {
            $('.insights-counter .current').text(zeroPad(slick.currentSlide + 1,2));
            $('.insights-counter .total').text(zeroPad(slick.slideCount,2));
        });
        $('.insight-slick-slider').slick({
            slideToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            infinite: false,
            arrows: true,
            fade: true,
            rows: 0,
            prevArrow: $('.insight-prev'),
            nextArrow: $('.insight-next'),
        })
        .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $('.insights-counter .current').text(zeroPad(nextSlide + 1,2));
        });
    } )( jQuery );
} )();